module.exports = __webpack_public_path__ + "static/media/37.a8beb0b6.png";